import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export function enter(_x) {
  return _enter.apply(this, arguments);
}

function _enter() {
  _enter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element) {
    var transitionName,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            transitionName = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            element.classList.remove('hidden');
            _context.next = 4;
            return transition('enter', element, transitionName);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _enter.apply(this, arguments);
}

export function leave(_x2) {
  return _leave.apply(this, arguments);
}

function _leave() {
  _leave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(element) {
    var transitionName,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            transitionName = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
            _context2.next = 3;
            return transition('leave', element, transitionName);

          case 3:
            element.classList.add('hidden');

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _leave.apply(this, arguments);
}

export function toggle(_x3) {
  return _toggle.apply(this, arguments);
}

function _toggle() {
  _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(element) {
    var transitionName,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            transitionName = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;

            if (!element.classList.contains('hidden')) {
              _context3.next = 6;
              break;
            }

            _context3.next = 4;
            return enter(element, transitionName);

          case 4:
            _context3.next = 8;
            break;

          case 6:
            _context3.next = 8;
            return leave(element, transitionName);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _toggle.apply(this, arguments);
}

function transition(_x4, _x5, _x6) {
  return _transition.apply(this, arguments);
}

function _transition() {
  _transition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(direction, element, animation) {
    var dataset, animationClass, transition, genesis, start, end;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            dataset = element.dataset;
            animationClass = animation ? "".concat(animation, "-").concat(direction) : direction;
            transition = "transition".concat(direction.charAt(0).toUpperCase() + direction.slice(1));
            genesis = dataset[transition] ? dataset[transition].split(" ") : [animationClass];
            start = dataset["".concat(transition, "Start")] ? dataset["".concat(transition, "Start")].split(" ") : ["".concat(animationClass, "-start")];
            end = dataset["".concat(transition, "End")] ? dataset["".concat(transition, "End")].split(" ") : ["".concat(animationClass, "-end")];
            addClasses(element, genesis);
            addClasses(element, start);
            _context4.next = 10;
            return nextFrame();

          case 10:
            removeClasses(element, start);
            addClasses(element, end);
            _context4.next = 14;
            return afterTransition(element);

          case 14:
            removeClasses(element, end);
            removeClasses(element, genesis);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _transition.apply(this, arguments);
}

function addClasses(element, classes) {
  var _element$classList;

  (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(classes));
}

function removeClasses(element, classes) {
  var _element$classList2;

  (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(classes));
}

function nextFrame() {
  return new Promise(function (resolve) {
    requestAnimationFrame(function () {
      requestAnimationFrame(resolve);
    });
  });
}

function afterTransition(element) {
  return new Promise(function (resolve) {
    // safari return string with comma separate values
    var computedDuration = getComputedStyle(element).transitionDuration.split(",")[0];
    var duration = Number(computedDuration.replace('s', '')) * 1000;
    setTimeout(function () {
      resolve();
    }, duration);
  });
}